<script setup>
import { ref, defineAsyncComponent } from 'vue';

const EmojiInput = defineAsyncComponent(
  () => import('shared/components/emoji/EmojiInput.vue')
);

const QUICK_EMOJIS = ['👍', '❤️', '😂', '😮', '😢', '👏'];

const emit = defineEmits(['react', 'close']);

const showFullPicker = ref(false);

function selectEmoji(emoji) {
  emit('react', emoji);
}

function onPickerClick(emoji) {
  emit('react', emoji);
}
</script>

<template>
  <div class="relative">
    <div
      class="flex items-center gap-0.5 bg-n-background border border-n-strong shadow-xl rounded-2xl px-2 py-1.5"
    >
      <button
        v-for="emoji in QUICK_EMOJIS"
        :key="emoji"
        class="flex items-center justify-center w-10 h-10 text-2xl rounded-xl hover:bg-n-slate-3 hover:scale-110 active:scale-95 transition-all duration-100 cursor-pointer select-none"
        @click.stop="selectEmoji(emoji)"
      >
        {{ emoji }}
      </button>
      <div class="w-px h-6 bg-n-strong mx-1 flex-shrink-0" />
      <button
        class="flex items-center justify-center w-10 h-10 rounded-xl hover:bg-n-slate-3 text-n-slate-10 hover:text-n-slate-12 transition-all duration-100 cursor-pointer"
        @click.stop="showFullPicker = !showFullPicker"
      >
        <span class="i-lucide-smile-plus text-xl" />
      </button>
    </div>

    <div
      v-if="showFullPicker"
      class="absolute z-50 bottom-full mb-2 ltr:left-0 rtl:right-0"
      @click.stop
    >
      <EmojiInput :on-click="onPickerClick" />
    </div>
  </div>
</template>
